/**
 * takes top block of strata workflow and checks if a convergence block is present
 * if there isn't but there are indicators present then it will set an error that there
 * is a loose block
 * @param {*} topBlock 
 */
function validateLooseBlock(block) {
    block.setWarningText(null, "role_warning")

    let rootBlock = block.getRootBlock()
    if(rootBlock.type !== 'globe_convergence') {
        rootBlock.setWarningText("Please attach block to a convergence block", "role_warning")
    }    
}

/**
 * Takes convergence block and checks if there are any indicators attached, if not
 * set covergence_warning on top convergence block
 * Also checks for output blocks
 * @param {*} convergenceBlock 
 */
function validateConvergenceBlock(convergenceBlock) {
    convergenceBlock.setWarningText(null, "convergence_warning")
    let descendants = convergenceBlock.getDescendants()

    let indicatorCount = 0;
    let outputCount = 0

    let indicatorBlockTypes = ['globe_indicator', 'globe_sat','globe_nbi']
    let outputBlockTypes = ['globe_interactive_map_viz', 'globe_update_dashboard']


    descendants.forEach((descendant) => {
        if(indicatorBlockTypes.includes(descendant.type)) indicatorCount++
        if(outputBlockTypes.includes(descendant.type)) outputCount++
    })

    if(indicatorCount === 0) {
        convergenceBlock.setWarningText("No indicators have been selected, please add some to your workflow", "convergence_warning")
    }
    if(outputCount === 0) {
        convergenceBlock.setWarningText("No outputs have been selected, please add some to your workflow", "convergence_warning")
    }
}

/**
 * function to validate strata blocks
 * @param {*} topBlock
 */

function validateGlobeBlock(topBlock) {
    let descendants = topBlock.getDescendants()
    descendants.forEach((descendant) => {
        validateLooseBlock(descendant)
        if(descendant.type === 'globe_convergence') {
            validateConvergenceBlock(descendant)
        }
    })
}

export {validateGlobeBlock}